module.exports = __webpack_public_path__ + "static/media/2.8910746d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/rhand/2.png
// module id = 1440
// module chunks = 0